import React from 'react';
import { useTranslation } from 'react-i18next';
import { Label, LabelProps } from '@patternfly/react-core';
import { ScheduleCellProps } from './types';

const DayPatternCell: React.FC<ScheduleCellProps> = ({ row }) => {
  const { t } = useTranslation();
  const classType = row?.original?.class_type || 'standard';
  const isNonStandard = classType === 'non_standard';

  const color: LabelProps['color'] = isNonStandard ? 'purple' : 'grey';
  const label = isNonStandard ? t('Non-standard') : t('Standard');

  return (
    <Label color={color} variant="filled">
      {label}
    </Label>
  );
};

export default DayPatternCell;
